import Vue from 'vue';
import type { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

/**
 * Module state
 */
interface State {
    caller:string;
    deviceConfig: any;
}

const moduleState: State = {
    caller: localStorage.getItem('Base/caller')||'',
    deviceConfig: window.localStorage.getItem('deviceConfig') ? window.localStorage.getItem('deviceConfig') : '',
};

/**
 * Module getters
 */
const moduleGetters: GetterTree<State, any> = {
    caller(state: State) {
        return state.caller || '';
    },
    async deviceConfig(state: State) : Promise<any> {
        if (state.deviceConfig) {
            return JSON.parse(state.deviceConfig);
        }
        return {useExternalScanner: true};
    },
};

/**
 * Module mutations
 */
const moduleMutations: MutationTree<State> = {
    setCaller(state: State, caller: string) {
        console.log(caller);
        state.caller = caller;
    },
    async setDeviceConfig(state: State, deviceConfig: any) {
        window.localStorage.setItem('deviceConfig',state.deviceConfig);
        state.deviceConfig = JSON.stringify(deviceConfig);
    },
};

/**
 * Module actions
 */
const moduleActions: ActionTree<State, any> = {

};

/**
 * Construct Module
 */
const module: Module<State, any> = {
    namespaced: true,
    state: moduleState,
    getters: moduleGetters,
    mutations: moduleMutations,
    actions: moduleActions,
};
export default module;
